import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-user-logins',
  templateUrl: './user-logins.component.html',
  styleUrls: ['./user-logins.component.css']
})
export class UserLoginsComponent implements OnInit {

  constructor(private api : ApiService) { }

  ngOnInit() {
    let request = this.api.getUserActivity();
    request.successFunc = x => this.userLogins = x;
    request.start();
  }

  userLogins;
  selectedLogin;

  selectLogin(login){
    this.selectedLogin = login;
  }
}
